const titleMinHeight = 54;
const titleRoundBorderWidth = 3;
const titleRoundRightMargin = 24;

const titlePadMinHeight = 46;
const titlePadRoundBorderWidth = 2;
const titlePadRoundRightMargin = 18;

const titleMobileMinHeight = 32;
const titleMobileRoundBorderWidth = 1.5;
const titleMobileRoundRightMargin = 16;

const styles = theme => ({
  root: {
    backgroundColor: "white",
    "& h1": {
      fontSize: "45px",
      lineHeight: "45px",
      fontWeight: theme.typography.fontWeightMedium,
      textTransform: "uppercase",
      color: theme.palette.greenMain,
      textShadow: "0px 2px 6px rgba(0, 0, 0, 0.18)",
      marginTop: "0px",
      marginBottom: "12px",
      ['@media (max-width: 768px)']: {
        fontSize: "20px",
        lineHeight: "26px",
        marginBottom: "3px",
        textShadow: "none",
      },
    },
    padding: "32px 0px",
    position: "relative",
    "& .MuiDialog-paper": {
      width: "100%",
      maxWidth: "85vw",
      padding: "70px 120px",
      borderRadius: "4px",
      ['@media (max-width: 992px)']: {
        padding: "70px 50px",
      },
      ['@media (max-width: 768px)']: {
        padding: "70px 25px",
        maxWidth: "100vw",
        margin: "0px",
        borderRadius: "0px"
      },
    },
    "& .MuiDialog-paperScrollPaper": {
      ['@media (max-width: 768px)']: {
        maxHeight: "100%",
      },
    },
    ['@media (max-width: 768px)']: {
      padding: "0px",
    },
  },
  container: {
    padding: "50px 16px 10px",
    fontSize: "20px",
    color: theme.palette.black,
    ['@media (max-width: 768px)']: {
      padding: "24px 24px",
    },
  },
  loader: {
    display: "block",
    margin: "0px auto"
  },
  titleContainer: {
    padding: "0px"
  },
  titleLogo: {
    width: "165px",
    height: "89px",
    ['@media (max-width: 768px)']: {
      width: "109px",
      height: "57px",
    },
  },
  intro: {
    margin: "30px 0px",
    fontSize: "18px",
    lineHeight: "24px",
    ['@media (max-width: 768px)']: {
      margin: "34px 0px -13px",
      fontSize: "12px",
      lineHeight: "18px",
      fontWeight: theme.typography.fontWeightLight
    },
  },
  content: {
    padding: "0px",
    overflow: "visible",
    "&:first-child": {
      paddingTop: "0px !important"
    }
  },
  accordionContainer: {
    position: "relative",
    padding: "50px 16px 10px",
    fontSize: "20px",
    color: theme.palette.black,
    ['@media (max-width: 768px)']: {
      padding: "24px 24px",
    },
  },
  accordionAnchors: {
    position: "absolute",
    opacity: "0",
    width: "100%",
    height: "100%"
  },
  accordion: {

  },
  section: {
    boxShadow: "none",
    margin: "40px 0px !important",
    "&:before": {
      opacity: "0"
    },
    ['@media (max-width: 992px)']: {
      margin: "32px 0px !important",
    },
    ['@media (max-width: 768px)']: {
      margin: "16px 0px !important",
    },
  },
  sectionTitle: {
    padding: "0px",
    minHeight: "1px",
    fontSize: "28px",
    "& .MuiExpansionPanelSummary-content": {
      margin: "0px",
    },
    "&:hover $sectionNumber": {
      color: theme.palette.bronze,
      borderColor: theme.palette.bronze,
      ['@media (max-width: 768px)']: {
        color: theme.palette.black,
        borderColor: theme.palette.black,
      },
    },
    ['@media (max-width: 992px)']: {
      fontSize: "22px",
    },
    ['@media (max-width: 768px)']: {
      fontSize: "16px",
    },
  },
  sectionTitleContent: {
    display: "flex",
    alignItems: "center",
    justifyContent: "start",
    flexGrow: "1",
    minHeight: `${titleMinHeight}px`,
  },
  sectionNumber: {
    flexBasis: `${titleMinHeight}px`,
    height: `${titleMinHeight}px`,
    flexShrink: "0",
    borderRadius: `${titleMinHeight / 2}px`,
    border: `${titleRoundBorderWidth}px solid ${theme.palette.black}`,
    marginRight: `${titleRoundRightMargin}px`,
    textAlign: "center",
    lineHeight: `${titleMinHeight - titleRoundBorderWidth * 2}px`,
    "&$current": {
      color: `${theme.palette.white} !important`,
      backgroundColor: `${theme.palette.bronze} !important`,
      borderColor: `${theme.palette.bronze} !important`
    },
    ['@media (max-width: 992px)']: {
      flexBasis: `${titlePadMinHeight}px`,
      height: `${titlePadMinHeight}px`,
      borderRadius: `${titlePadMinHeight / 2}px`,
      border: `${titlePadRoundBorderWidth}px solid ${theme.palette.black}`,
      marginRight: `${titlePadRoundRightMargin}px`,
      lineHeight: `${titlePadMinHeight - titlePadRoundBorderWidth * 2}px`,
    },
    ['@media (max-width: 768px)']: {
      flexBasis: `${titleMobileMinHeight}px`,
      height: `${titleMobileMinHeight}px`,
      borderRadius: `${titleMobileMinHeight / 2}px`,
      border: `${titleMobileRoundBorderWidth}px solid ${theme.palette.black}`,
      marginRight: `${titleMobileRoundRightMargin}px`,
      lineHeight: `${titleMobileMinHeight - titleMobileRoundBorderWidth * 2}px`,
    },
  },
  sectionName: {
    flexGrow: "1"
  },
  sectionContent: {
    padding: `20px 0px 40px ${titleMinHeight + titleRoundRightMargin}px`,
    ['@media (max-width: 992px)']: {
      padding: `16px 0px`,
    },
    ['@media (max-width: 768px)']: {
      padding: `16px 0px`,
    },
  },
  editProfileRow: {
    display: "flex",
    justifyContent: "flex-end",
    marginBottom: "30px",
    ['@media (max-width: 768px)']: {
      marginBottom: "12px",
      marginTop: "-16px"
    }
  },
  editProfile: {
    border: "none",
    color: theme.palette.grayText,
    alignItems: "center",
    fontSize: "20px",
    textTransform: "capitalize",
    paddingRight: "0px",
    ['@media (max-width: 768px)']: {
      fontSize: "13px",
    },
  },
  editProfileIcon: {
    marginRight: "14px",
    ['@media (max-width: 768px)']: {
      marginRight: "14px",
      width: "20px",
      height: "20px"
    },
  },
  personalInfo: {
    width: "100%"
  },
  questionnaire: {
    width: "100%"
  },
  bankData: {
    width: "100%"
  },
  overview: {
    width: "100%"
  },
  buttonContainer: {
    marginTop: "35px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0px 12px",
    ['@media (max-width: 768px)']: {
      margin: "32px -12px 0px"
    },
  },
  button: {
    minWidth: "410px",
    ['@media (max-width: 768px)']: {
      minWidth: "1px",
      width: "100%",
      maxWidth: "350px"
    },
  },
  current: {

  },
});

export default styles;